export class AdminRestaurantFinancialMetric {
  companyId: number

  userId: string

  companyName: string

  totalOrdersCurrentMonth: number

  cancelledOrdersCurrentMonth: number

  finishedOrdersCurrentMonth: number

  paidOrdersCurrentMonth: number

  manualExternalOrdersCurrentMonth: number

  grossOrdersAmountCurrentMonth: number

  manualExternalOrdersAmountCurrentMonth: number

  manualExternalOrdersNetAmountCurrentMonth: number

  splitAmountCurrentMonth: number

  platformFeeAmountCurrentMonth: number

  restaurantAmountCurrentMonth: number

  courierAmountCurrentMonth: number

  estimatedRestaurantEarningsCurrentMonth: number

  averageEarningsPerPaidOrderCurrentMonth: number

  constructor(data: Partial<AdminRestaurantFinancialMetric> = {}) {
    this.companyId = data.companyId ?? 0

    this.userId = data.userId ?? ""

    this.companyName = data.companyName ?? ""

    this.totalOrdersCurrentMonth = data.totalOrdersCurrentMonth ?? 0

    this.cancelledOrdersCurrentMonth = data.cancelledOrdersCurrentMonth ?? 0

    this.finishedOrdersCurrentMonth = data.finishedOrdersCurrentMonth ?? 0

    this.paidOrdersCurrentMonth = data.paidOrdersCurrentMonth ?? 0

    this.manualExternalOrdersCurrentMonth = data.manualExternalOrdersCurrentMonth ?? 0

    this.grossOrdersAmountCurrentMonth = data.grossOrdersAmountCurrentMonth ?? 0

    this.manualExternalOrdersAmountCurrentMonth = data.manualExternalOrdersAmountCurrentMonth ?? 0

    this.manualExternalOrdersNetAmountCurrentMonth = data.manualExternalOrdersNetAmountCurrentMonth ?? 0

    this.splitAmountCurrentMonth = data.splitAmountCurrentMonth ?? 0

    this.platformFeeAmountCurrentMonth = data.platformFeeAmountCurrentMonth ?? 0

    this.restaurantAmountCurrentMonth = data.restaurantAmountCurrentMonth ?? 0

    this.courierAmountCurrentMonth = data.courierAmountCurrentMonth ?? 0

    this.estimatedRestaurantEarningsCurrentMonth = data.estimatedRestaurantEarningsCurrentMonth ?? 0

    this.averageEarningsPerPaidOrderCurrentMonth = data.averageEarningsPerPaidOrderCurrentMonth ?? 0
  }
}
